'use strict';

angular.module('authController', [])
.controller('AuthController', ['$scope','$log','$window', '$rootScope','$location','AuthenticationService', 'localstorage', 'BuyerService',
    function ($scope, $log, $window, $rootScope, $location, AuthenticationService, localstorage, BuyerService) {

        var appInfo = $rootScope.appInfo;

        //reset login status
        AuthenticationService.ClearCredentials();

        $rootScope.auth = false;
        $rootScope.watchlistNotificationCount = 0;

        //Login function
        $scope.login = function () {
             $rootScope.loading = true;
             $rootScope.firstOpen = true;

             AuthenticationService.Login('seller', $scope.username, $scope.password, function (response) {
                if (response.access) {
                    AuthenticationService.SetAccess(response);
                    BuyerService.getWatchlistNotificationCount()
                    .then(function(data){
                        $rootScope.username = $scope.username;
                        $rootScope.watchlistNotificationCount = parseInt(data);
                        var d = new Date();
                        var lastLogInDate = parseInt(d.getTime()/1000);
                        localstorage.set('lastLogInDate', lastLogInDate);
                        if(localstorage.get('freshLogin') == 'no') {
                            $location.path('/watchlist');    
                        } else {
                            
                            $location.path('/preferences');    
                            //set localstorage variable to save they have login at least once
                            //once set never removed
                            localstorage.set('freshLogin', 'no');
                        }
                    });
                } else {
                    $rootScope.username = '';
                    alert('Invalid login.');
                    $scope.error = response.error.message;
                    $rootScope.loading = false;
                }
            });
        };

        $scope.loadWebsite = function(){
            window.location.href = 'http://www.wiseberry.com.au';
        }


        //Logout function
        $scope.logout = function () {
            var accessKey = $rootScope.currentUser.authdata;
            AuthenticationService.LogOut(key, accessKey, function(data) {
               AuthenticationService.ClearCredentials();
               $location.path('/logout');
            })
        };

        $window.scrollTo(0, angular.element('.login').offsetTop);  

}]);